import { A11yBooleanInput } from '../interfaces/a11y.interfaces';

export abstract class A11yCarouselContext {
  public abstract registerDot(dot: A11yCarouselDotContext): void;
  public abstract unregisterDot(dot: A11yCarouselDotContext): void;
}

export abstract class A11yCarouselDotContext {
  public abstract khA11yCarouselDotIndex: number;
  public abstract khA11yCarouselDotActive: A11yBooleanInput;
}
